import { TranslationRepository } from '../data/translation-repository';
import { PublishStatus, ApplicationType } from '../types/translation-types';

export class GetPublishStatusUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(applicationType: ApplicationType): Promise<PublishStatus> {
    return this.repository.getPublishStatus(applicationType);
  }
}
